export default "__VITE_ASSET__D$xIK8op__"